"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAiApi = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const StreamClient_1 = require("../cutil/StreamClient");
const ErrorUtil_1 = require("../api/ErrorUtil");
const AskBrain_1 = require("../api/askBrainTyped/AskBrain");
const updateEdge_1 = require("./updateEdgeType/updateEdge");
const updateNode_1 = require("./updateNodeType/updateNode");
const GlobalContext_1 = require("./globalContextTyped/GlobalContext");
const FunctionSuggestions_1 = require("./functionSuggestionsTyped/FunctionSuggestions");
const ToolPieces_1 = require("./toolPiecesTyped/ToolPieces");
const Blueprints_1 = require("./blueprintsTyped/Blueprints");
const BlueprintDetail_1 = require("./blueprintDetailTyped/BlueprintDetail");
const Blueprint_1 = require("./blueprintTyped/Blueprint");
const BlueprintV2_1 = require("./blueprintTyped/BlueprintV2");
const ToolBoxInput_1 = require("./blueprintTyped/ToolBoxInput");
const CotTemplateResponseData_1 = require("../../cases/cot/typed/CotTemplateResponseData");
const dynamicLink_1 = require("./dynamicLinkTyped/dynamicLink");
const ChatCompletionsTyped_1 = require("./chatCompletionTyped/ChatCompletionsTyped");
const Youtube_1 = require("./youtubeTyped/Youtube");
const cotflow_1 = require("./cotTyped/cotflow");
const uploadResponse_1 = require("./uploadTyped/uploadResponse");
const viewBuilderGraph_1 = require("./viewBuilderTyped/viewBuilderGraph");
const VBBlueprintExecute_1 = require("./viewBuilderTyped/VBBlueprintExecute");
class OpenAiApi {
    constructor(restClient, streamRequest, xhrClient) {
        this.restClient = restClient;
        this.streamRequest = streamRequest;
        this.xhrClient = xhrClient;
    }
    completionsGeneration(objectId, input) {
        return this.streamRequest.request({
            path: "/stream/bas-demo-v4/nlp/completions_generation",
            data: {
                identifier_type: "object_id",
                identifier_value: objectId,
                stream: true,
                variables: { input: input },
            },
        });
    }
    completionsGenerationNoStream(url, domain, identifierType, identifierValue, stream, variables, uuid, topic) {
        const data = {
            identifier_type: identifierType,
            identifier_value: identifierValue,
            variables: variables,
            pubsub_topic: topic,
        };
        if (domain) {
            data["domain"] = domain;
        }
        if (stream) {
            data["stream"] = stream;
        }
        return this.restClient.post(url, data, undefined, undefined, undefined, uuid);
    }
    splitOutput(input, uuid) {
        return this.restClient
            .post("/stream/bas-demo-v4/nlp/completions_generation", {
            identifier_type: "file",
            identifier_value: "brain_studios_xxx_shard_splitting.model",
            stream: false,
            variables: { input: input },
        }, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    askBrain(input, pubsub_topic, uuid) {
        return this.streamRequest.request({
            path: "/stream/langchain/v6/ask_brain",
            data: {
                stream: true,
                query: input,
                pubsub_topic: pubsub_topic,
                stream_version: "v1",
            },
            queryParameters: {},
            headers: {},
            method: StreamClient_1.RestMethod.POST,
            uuid,
        });
    }
    blueprints(input, uuid) {
        return this.streamRequest.request({
            path: "/stream/langchain/toolbox/v2/blueprints/execute/stream",
            data: {
                blueprint_name: input,
            },
            queryParameters: {},
            headers: {},
            method: StreamClient_1.RestMethod.POST,
            uuid,
            isJsonSteaming: true,
        });
    }
    blueprintsV2(data, uuid) {
        return this.streamRequest.request({
            path: "/stream/langchain/toolbox/v2/blueprints/execute",
            data: data,
            queryParameters: {},
            headers: {},
            method: StreamClient_1.RestMethod.POST,
            uuid,
            isJsonSteaming: true,
        });
    }
    chatCompletions(data, uuid) {
        return this.streamRequest.request({
            path: "/stream/openai/v1/chat/completions",
            data: data,
            queryParameters: {},
            headers: {},
            method: StreamClient_1.RestMethod.POST,
            uuid,
        });
    }
    onboardingChatStream(data, uuid) {
        return this.streamRequest.request({
            path: "/stream/cot/onboarding/chat",
            data: Object.assign({}, data, { stream: true }),
            queryParameters: {},
            headers: {},
            method: StreamClient_1.RestMethod.POST,
            uuid,
        });
    }
    onboardingChat(data, uuid) {
        return this.restClient
            .post("/be/cot/onboarding/chat", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ChatCompletionsTyped_1.OnboardingChatRespose));
    }
    onboardingBuild(data, uuid) {
        return this.restClient
            .post("/be/cot/onboarding/build", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(cotflow_1.Cotflow));
    }
    onboardingBuildVbTb(data, uuid) {
        return this.restClient
            .post("/be/cot/onboarding/build_vb_tb", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(viewBuilderGraph_1.ViewBuilderGraph));
    }
    onboardingVBBlueprintExecute(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/execute", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(VBBlueprintExecute_1.VBBlueprintExecuteResponse));
    }
    onboardingVBBlueprintExecuteWithSocket(data, pubsub_topic, uuid) {
        return this.restClient.post("/be/langchain/toolbox/v2/blueprints/execute", { ...data, pubsub_topic }, undefined, undefined, undefined, uuid);
    }
    onboardingAppInfo(data, uuid) {
        return this.restClient
            .post("/be/cot/onboarding/app_info", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ChatCompletionsTyped_1.OnboardingAppInfoRespose));
    }
    instantIntent(queryParameters, uuid) {
        return this.restClient
            .get("/be/bas-demo-v4/nlp/instant_intent", queryParameters, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ChatCompletionsTyped_1.PromptModelResponse));
    }
    conversation(data, uuid) {
        return this.restClient
            .post("/be/fot/conversation", data, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getToolPiecesList(uuid) {
        return this.restClient
            .get("/be/langchain/toolbox/v2/toolpieces/list", undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolPieces_1.ToolPieces));
    }
    toolBoxInputs(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/inputs", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolBoxInput_1.ToolBoxInput));
    }
    getBlueprintsList(uuid) {
        return this.restClient
            .get("/be/langchain/toolbox/v2/blueprints/list", undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Blueprints_1.Blueprints));
    }
    searchBlueprints(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/search", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Blueprints_1.Blueprints));
    }
    searchToolPieces(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/search", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolPieces_1.ToolPieces));
    }
    blueprintDetail(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/details", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(BlueprintDetail_1.BlueprintDetails));
    }
    blueprintFeedback(data) {
        return this.restClient.post("/be/langchain/toolbox/v2/blueprints/update", data).then(res => res.validate());
    }
    blueprintDislike(data) {
        return this.restClient.post("/be/langchain/toolbox/v2/feedback", data).then(res => res.validate());
    }
    blueprintVocabulary(data) {
        return this.restClient.post("/be/langchain/vocabulary/autocomplete", data).then(res => res.validate());
    }
    toolPiecesDetail(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/details", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Blueprint_1.ToolPieceData));
    }
    missingApis(uuid) {
        return this.restClient
            .get("/be/langchain/toolbox/v2/blueprints/missing_apis", undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Blueprint_1.MissingApis));
    }
    blueprintBuilder(data, uuid) {
        return this.restClient
            .post("/be/langchain/blueprint_builder", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Blueprint_1.BlueprintResponse));
    }
    blueprintBuilderV2(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/build", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(BlueprintV2_1.BlueprintResponseV2));
    }
    blueprintBuilderJust(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/just_build", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(BlueprintV2_1.BlueprintResponseV2));
    }
    deleteToolPieces(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/delete", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Object));
    }
    deleteBlueprints(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/delete", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Object));
    }
    buildGraph(data, uuid) {
        return this.restClient
            .post("/be/cot/build_graph", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(cotflow_1.Cotflow));
    }
    buildGraphV2(data, uuid) {
        return this.restClient
            .post("/be/cot/v2/build_graph", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(cotflow_1.Cotflow));
    }
    saveBlueprints(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/blueprints/add", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Object));
    }
    addToolPiece(data, uuid) {
        return this.restClient
            .post("/be/langchain/toolbox/v2/toolpieces/add", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(ToolPieces_1.ToolPiece));
    }
    askBrainAnswer(query, pubsub_topic, uuid) {
        return this.restClient
            .post("/be/langchain/v6/ask_brain", { query, pubsub_topic }, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(AskBrain_1.AskBrainData));
    }
    getStockInfo(text, uuid) {
        return this.restClient
            .get("/be/svc-adapter/stock/symbol", { text }, undefined, undefined, uuid)
            .then(res => {
            return res.parseError(res => {
                const defaultErrorMsg = ErrorUtil_1.ErrorUtil.parseRestResponse(res);
                return defaultErrorMsg || "Get stock failed";
            });
        })
            .then(res => res.validate());
    }
    alphafold(text, uuid, pubsub_topic) {
        return this.restClient.get("/be/svc-adapter/alphafold/search", { text, pubsub_topic }, undefined, undefined, uuid);
    }
    stableai(prompt, from, uuid, topic) {
        // return this.restClient.post("/be/lambda/function/stableai", { prompt, from });
        return this.restClient.post("/be/lambda/function/stableai", {
            prompt,
            from,
            json: true,
            public_topic: topic,
        }, undefined, undefined, undefined, uuid);
    }
    midjourney(prompt, topic, uuid) {
        return this.restClient
            .post("/be/svc-adapter/midjourney/v2/imagine", { prompt, topic }, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    midjourneyMessage(messageId, uuid) {
        return this.restClient
            .get("/be/svc-adapter/midjourney/v2/message", { id: messageId }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    imageSearch(q, uuid, public_topic) {
        return this.restClient.get("/be/shopping/serpapi/search", {
            q,
            engine: "google_images",
            public_topic,
        }, undefined, undefined, uuid);
    }
    updateEdge(data, uuid) {
        return this.restClient
            .post("/be/langchain/canvas_descriptions/update_edge", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(updateEdge_1.UpdateEdgeResponse));
    }
    updateNode(data, uuid) {
        return this.restClient
            .post("/be/langchain/canvas_descriptions/update_nodes", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(updateNode_1.UpdateNodeResponse));
    }
    indexers(data, uuid) {
        return this.restClient
            .post("/be/vectordb/indexers/", data, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    upload(data, uuid) {
        return this.restClient
            .post("/api/me/upload/studios", data, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    download(url, uuid) {
        return this.restClient
            .get("/api/me/upload/studios", { url }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getJdShoppingInfo(keyword, page, uuid, pubsub_topic) {
        return this.getJdShoppingBase(keyword, page, uuid, pubsub_topic).then(res => res.validate());
    }
    getJdShoppingBase(keyword, page, uuid, pubsub_topic) {
        return this.restClient.get("/be/svc-adapter/jd/search", { keyword, page, pubsub_topic }, undefined, undefined, uuid);
    }
    getAmazonShoppingInfo(query, page, uuid, pubsub_topic) {
        return this.getAmazonShoppingInfoBase(query, page, uuid, pubsub_topic).then(res => res.validate());
    }
    getAmazonShoppingInfoBase(query, page, uuid, pubsub_topic) {
        return this.restClient.get("/be/svc-adapter/purchasing/shop-search", {
            query,
            page,
            pubsub_topic,
        }, undefined, undefined, uuid);
    }
    getWeeeGroceriesInfo(keyword, page, uuid, pubsub_topic) {
        return this.getWeeeGroceriesBase(keyword, page, uuid, pubsub_topic).then(res => res.validate());
    }
    getWeeeGroceriesBase(keyword, page, uuid, pubsub_topic) {
        return this.restClient.get("/be/svc-adapter/sayweee/search", {
            keyword,
            page,
            pubsub_topic,
        }, undefined, undefined, uuid);
    }
    getWeeeShoppingInfo(keyword, page, uuid) {
        return this.getWeeeShoppingBase(keyword, page, uuid).then(res => res.validate());
    }
    getWeeeShoppingBase(keyword, page, uuid, pubsub_topic) {
        return this.restClient.get("/be/svc-adapter/sayweee/search", {
            keyword,
            page,
            pubsub_topic,
        }, undefined, undefined, uuid);
    }
    getYoutube(keyword, pagination, uuid) {
        if (pagination === undefined) {
            return this.restClient
                .get("/be/svc-adapter/youtube/v2/search", {
                keyword,
            }, undefined, undefined, uuid)
                .then(res => res.validate());
        }
        return this.restClient
            .post("/be/svc-adapter/youtube/v2/search", pagination, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    getYoutubeV2(data, uuid) {
        return this.restClient
            .post("/be/svc-adapter/youtube/v2/search", data, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(Youtube_1.YoutubeResponse));
    }
    getAddress(keyword, uuid) {
        return this.restClient
            .get("/be/svc-adapter/google/maps/address-gps", {
            address: keyword,
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    async getMapTextSearch(keyword, location, uuid) {
        const locationStr = (0, is_blank_1.default)(location) ? "" : `${location[1]},${location[0]}`;
        return await this.restClient
            .get(`/be/svc-adapter/google/maps/textsearch?query=${keyword}&location=${locationStr}`, undefined, undefined, undefined, uuid)
            .then(res => res.validate());
    }
    async getAddressDetail(placeid) {
        return await this.restClient
            .get("/be/svc-adapter/google/maps/place_details", {
            placeid,
        })
            .then(res => res.validate());
    }
    getRestaurantList(lat, lng, dish, limit, logo, open_now, mode, sorts, query, offset, uuid) {
        // ?lat=30.5740463&lng=104.0602464&dish=0&limit=5&logo=1&open_now=true&mode=delivery&sorts=default&query=pizza&offset=0
        return this.getRestaurantListBase(lat, lng, dish, limit, logo, open_now, mode, sorts, query, offset, uuid).then(res => res.validate());
    }
    getRestaurantListBase(lat, lng, dish, limit, logo, open_now, mode, sorts, query, offset, uuid, pubsub_topic) {
        // ?lat=30.5740463&lng=104.0602464&dish=0&limit=5&logo=1&open_now=true&mode=delivery&sorts=default&query=pizza&offset=0
        return this.restClient.get("/be/svc-adapter/food/v2/search", {
            lat,
            lng,
            dish,
            limit,
            logo,
            open_now,
            mode,
            sorts,
            query,
            offset,
            pubsub_topic,
        }, undefined, undefined, uuid);
    }
    getRestaurantListByNext(next, uuid, pubsub_topic) {
        return this.restClient.get(`/be/svc-adapter/${next}`, { pubsub_topic }, undefined, undefined, uuid);
    }
    getRestaurantInfo(id, by, lat, lng, mode, isCheckout) {
        // ?lat=30.5740463&lng=104.0602464&mode=delivery&isCheckout=0&by=DOORDASH&id=93714
        return this.restClient
            .get("/be/svc-adapter/food/detail", {
            lat,
            lng,
            mode,
            isCheckout,
            by,
            id,
        })
            .then(res => res.validate());
    }
    buyShop(url) {
        return this.restClient
            .get("/be/svc-adapter/natural/proxy", {
            url,
        })
            .then(res => res.validate());
    }
    postWithStreaming(url, params, uuid) {
        return this.streamRequest.request({ path: url, data: params, uuid });
    }
    postWithNoStreaming(url, params) {
        return this.restClient.post(url, params).then(res => res.validate());
    }
    globalContext(edgeId, graph, uuid) {
        return this.restClient
            .post("/be/cot/global_context_v2", { node_id: edgeId, graph }, undefined, undefined, undefined, uuid)
            .then(res => res.toModelFromType(GlobalContext_1.GlobalContextData));
    }
    getSuggestedFunctions(nodeId, projectData) {
        return this.restClient
            .post("/be/cot/predict_next_node_v1 ", { node_id: nodeId, graph: projectData })
            .then(res => res.toModelFromType(FunctionSuggestions_1.FunctionSuggestions));
    }
    getGenerationPrompt(params) {
        return this.restClient.post("/be/bas-demo-v4/nlp/prompt_generation", params).then(res => res.validate());
    }
    getCotTemplateGraph(url, params) {
        return this.restClient.post(url, params).then(res => res.toModelFromType(CotTemplateResponseData_1.CotTemplateResponseData));
    }
    completionsGenerationV2(params) {
        return this.restClient.post("/be/bas-demo-v4/nlp/completions_generation", params).then(res => res.validate());
    }
    dynamicLink(params) {
        return this.restClient
            .post("/analytics/studios_share/dynamiclink/", params)
            .then(res => res.toModelFromType(dynamicLink_1.DynamicLink));
    }
    dynamicLinkV2(params) {
        return this.restClient
            .post("/analytics/studios_share_v2/dynamiclink/", params)
            .then(res => res.toModelFromType(dynamicLink_1.DynamicLink));
    }
    uploadStudios(data, callbackMethods, uuid) {
        return this.xhrClient
            .post("/api/me/upload/studios", data, undefined, undefined, undefined, uuid, callbackMethods)
            .then(res => res.toModelFromType(uploadResponse_1.UploadResponse));
    }
    tts(text, uuid) {
        return this.restClient
            .get("/be/vectordb/tts", {
            text,
        }, undefined, undefined, uuid)
            .then(res => res.validate());
    }
}
exports.OpenAiApi = OpenAiApi;
